import { Component } from '@angular/core';
import { AnyoCurdComponent } from 'projects/app-core/src/app/models/AnyoCrudComponent';
import { AuthService } from 'projects/app-core/src/auth/auth.service';
import { IAnyoUser } from 'projects/app-core/src/auth/models/IAnyoUser';
import { MasterdataService } from '../../../services/masterdata.service';
import { IAnyoError } from 'projects/app-core/src/models/errorModal';
import { ToastService } from 'projects/app-core/src/app/services/toastr.service';
import { EmailTemplatesService } from '../../../services/email-templates.service';
import { UtilsService } from 'projects/app-core/src/service/utils.service';
import { sanitizeHtml } from 'projects/app-core/src/app/utils/sanitize-html.util';
import { AddNewEmailTemplateReq } from '../../../models/email-templates/addEmailTemplateReq';
import { EmailTemplateStatus } from '../../../models/email-templates/emailTemplate';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

interface DropdownOptions {
  value: string;
  data: string;
}

@Component({
  selector: 'app-crud',
  templateUrl: './crud.component.html',
  styleUrl: './crud.component.scss',
})
export class CrudComponent extends AnyoCurdComponent {
  isEditable = false;
  listOfSelectedValue: string[] = [];
  selectedTags: string[] = [];
  partners: DropdownOptions[] = [];
  allPartners = false;
  fewPartners = false;
  templateName = '';
  subject = '';
  body = '';
  ctaButtonText = '';
  ctaButtonLink = '';
  footerMessage = '';
  description = '';
  tags: string[] = [];
  allTags: DropdownOptions[] = [];
  thumbnailFile!: File;
  bannerFile!: File;
  htmlFileUrl: string = '';
  thumbnailUrl: string | ArrayBuffer | null =
    'https://cdn.anyo.app/mail-assets/Newletter.png';
  previewBannerUrl: string | ArrayBuffer | null =
    'https://cdn.anyo.app/mail-assets/Newletter.png';
  index = 0;
  status: EmailTemplateStatus = EmailTemplateStatus.DRAFT;
  templateId!: string;
  isVisible: boolean = true;

  addItem(input: HTMLInputElement): void {
    const value = input.value;
    if (this.tags.indexOf(value) === -1) {
      this.tags = [...this.tags, input.value || `New item ${this.index++}`];
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.thumbnailFile = file;
      const reader = new FileReader();
      reader.onload = () => {
        this.previewBannerUrl = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  onThumbnailSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.bannerFile = file;
      const reader = new FileReader();
      reader.onload = () => {
        this.thumbnailUrl = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  selectTag(event: Event) {}

  constructor(
    protected override auth: AuthService,
    private masterDataService: MasterdataService,
    private toastrService: ToastService,
    private emailTemplateService: EmailTemplatesService,
    private utils: UtilsService,
    private activatedRoute: ActivatedRoute,
    private sanitizer: DomSanitizer,
  ) {
    super(auth);
  }

  override async getData(user?: IAnyoUser): Promise<void> {
    if (user) {
      this.pageLoading = true;
      this.getMasterData();
      this.emailTemplateService.getTags().subscribe({
        next: (value: string[]) => {
          this.tags = value.map((data) => this.utils.fromSnakeCase(data));
          this.pageLoading = false;
          this.getEmailTemplateData();
        },
        error: (err) => {
          this.pageLoading = false;
          const errorBody = err.error as IAnyoError;
          this.toastrService.showAnyoErrorToast(errorBody.description);
        },
      });
    }
  }
  safeBodyContent!: SafeHtml;
  getEmailTemplateData() {
    const id = this.activatedRoute.snapshot.params['id'];
    this.templateId = id;
    if (id) {
      this.isEditable = true;
      this.emailTemplateService.getEmailTemplateId(id).subscribe({
        next: (value) => {
          this.htmlFileUrl = value.htmlFileUrl;
          this.ctaButtonLink = value.ctaLink;
          this.ctaButtonText = value.ctaText;
          this.templateName = value.title;
          this.previewBannerUrl = value.bannerImageUrl;
          this.thumbnailUrl = value.thumbnailImageUrl;
          this.footerMessage = value.footerMessage;
          this.subject = value.subject;
          this.body = value.bodyContent;
          const plainText = value.bodyContent || ''; // coming from API
          const withBreaks = plainText.replace(/\n/g, '<br/>');
          this.safeBodyContent = this.sanitizer.bypassSecurityTrustHtml(
            sanitizeHtml(withBreaks),
          );
          this.isVisible = value.isVisible;

          // Replace placeholder in your HTML template string:
          // const finalHtml = html.replace('{{bodyContent}}', bodyContentHtml);

          this.allPartners = value.allPartnersApplicable;
          if (!value.allPartnersApplicable && value.applicablePartnerIds) {
            this.listOfSelectedValue = value.applicablePartnerIds;
          }
          this.selectedTags = value.tags.map((data) =>
            this.utils.fromSnakeCase(data),
          );
        },
        error: (err) => {
          const errorBody = err.error as IAnyoError;
          this.toastrService.showAnyoErrorToast(errorBody.description);
        },
      });
    }
  }

  override async get(paramsId: string): Promise<void> {}
  createPublished() {
    this.status = EmailTemplateStatus.PUBLISHED;
    this.create();
  }

  createAsDraft() {
    this.status = EmailTemplateStatus.DRAFT;
    this.create();
  }

  override async create(): Promise<void> {
    this.pageLoading = true;
    const html = document.querySelector('table')?.outerHTML;
    const tags = this.selectedTags.map((data) => this.utils.toSnakeCase(data));
    const req: AddNewEmailTemplateReq = {
      subject: this.subject,
      templateName: this.templateName,
      bannerImageUrl: this.previewBannerUrl as string,
      bodyContent: this.body,
      ctaText: this.ctaButtonText,
      ctaLink: this.ctaButtonLink,
      footerMessage: this.footerMessage,
      description: this.description,
      tags: tags,
      allPartnersApplicable: this.allPartners,
      thumbnailImageUrl: this.thumbnailUrl as string,
      status: this.status,
      htmlFileUrl: '',
      isVisible: this.isVisible,
    };
    if (!this.allPartners) {
      req.applicablePartners = this.listOfSelectedValue;
    }
    if (this.bannerFile) {
      req.bannerImageUrl = await this.utils.handleMultipleFileUpload(
        this.bannerFile,
        'email-templates',
        'banner',
      );
    }
    if (this.thumbnailFile) {
      req.thumbnailImageUrl = await this.utils.handleMultipleFileUpload(
        this.thumbnailFile,
        'email-templates',
        'thumbnail',
      );
    }
    const blob = new Blob([html!], { type: 'text/html' });

    const htmlFile = new File([blob], `anyo_emailer.html`, {
      type: 'text/html',
    });

    const cdnUrl = await this.utils.handleMultipleFileUpload(
      htmlFile,
      'email-templates/mails/templates',
      'anyo_emailer',
    );
    req.htmlFileUrl = cdnUrl.replace('https://cdn.anyo.app/', '');
    this.emailTemplateService.addEmailTemplate(req).subscribe({
      next: () => {
        this.pageLoading = false;
        this.toastrService.showSuccess('Email template added!!');
      },
      error: (err) => {
        this.pageLoading = false;
        const errorBody = err.error as IAnyoError;
        this.toastrService.showAnyoErrorToast(errorBody.description);
      },
    });
  }

  updatePublished() {
    this.status = EmailTemplateStatus.PUBLISHED;
    this.update();
  }

  updateAsDraft() {
    this.status = EmailTemplateStatus.DRAFT;
    this.update();
  }

  override async update(): Promise<void> {
    this.pageLoading = true;
    const html = document.querySelector('table')?.outerHTML;

    const tags = this.selectedTags.map((data) => this.utils.toSnakeCase(data));
    const req: AddNewEmailTemplateReq = {
      subject: this.subject,
      templateName: this.templateName,
      bannerImageUrl: this.previewBannerUrl as string,
      bodyContent: this.body,
      ctaText: this.ctaButtonText,
      ctaLink: this.ctaButtonLink,
      footerMessage: this.footerMessage,
      description: this.description,
      tags: tags,
      allPartnersApplicable: this.allPartners,
      thumbnailImageUrl: this.thumbnailUrl as string,
      status: this.status,
      htmlFileUrl: this.htmlFileUrl,
      isVisible: this.isVisible,
    };
    if (!this.allPartners) {
      req.applicablePartners = this.listOfSelectedValue;
    }
    if (this.bannerFile) {
      req.bannerImageUrl = await this.utils.handleMultipleFileUpload(
        this.bannerFile,
        'email-templates',
        'banner',
      );
    }
    if (this.thumbnailFile) {
      req.thumbnailImageUrl = await this.utils.handleMultipleFileUpload(
        this.thumbnailFile,
        'email-templates',
        'thumbnail',
      );
    }
    const blob = new Blob([html!], { type: 'text/html' });

    const htmlFile = new File([blob], `anyo_emailer.html`, {
      type: 'text/html',
    });

    const cdnUrl = (req.htmlFileUrl = await this.utils.handleMultipleFileUpload(
      htmlFile,
      'email-templates/mails/templates',
      'anyo_emailer',
    ));
    const finalUrl = cdnUrl.replace('https://cdn.anyo.app/', '');
    req.htmlFileUrl = finalUrl;
    this.emailTemplateService
      .updateEmailTemplate(this.templateId, req)
      .subscribe({
        next: () => {
          this.pageLoading = false;
          this.toastrService.showSuccess('Email template updated!!');
        },
        error: (err) => {
          this.pageLoading = false;
          const errorBody = err.error as IAnyoError;
          this.toastrService.showAnyoErrorToast(errorBody.description);
        },
      });
  }

  bodyChange($event: string) {
    const plainText = $event || ''; // coming from API
    const withBreaks = plainText.replace(/\n/g, '<br/>');
    this.safeBodyContent = this.sanitizer.bypassSecurityTrustHtml(
      sanitizeHtml(withBreaks),
    );
  }

  getMasterData() {
    this.masterDataService.partnerMasterDataList().subscribe({
      next: (value) => {
        this.partners = value.map((data) => {
          return {
            data: data.companyName!,
            value: data._id!,
          };
        });
      },
      error: (err) => {
        const errorBody = err.error as IAnyoError;
        this.toastrService.showAnyoErrorToast(errorBody.description);
      },
    });
  }

  sendTestEmail() {
    const html = document.querySelector('table')?.outerHTML;
    this.emailTemplateService.sendMailHtml({ html: html || '' }).subscribe({
      next: () => {
        this.toastrService.showSuccess('Success');
      },
      error: () => {
        this.toastrService.showError('Error');
      },
    });
  }
}
